













import { Vue, Component, Prop } from 'vue-property-decorator';
import { EProgressBarType } from './enums/progress-bar-type';

@Component({
  name: 'BaseProgressBar',
})
export default class BaseProgressBar extends Vue {
  @Prop({ default: 0 }) value: number;
  @Prop({ default: 0 }) min: number;
  @Prop({ default: 100 }) max: number;
  @Prop({ default: false }) error: boolean;
  @Prop({ default: false }) completed: boolean;
  @Prop({ default: EProgressBarType.Primary }) type: EProgressBarType;
  @Prop({ default: false }) disableWaveAnimation: boolean;

  get width(): string {
    if (this.completed || this.error) {
      return '100%';
    }
    const width = (this.value / this.max) * 100;
    return `${width}%`;
  }
}
